import { readJson, readStatus } from './apiResponse';

var getUnreadMessagesFromDatabase = () => {
    return dispatch => {
        const token = localStorage.token;
        if (token) {
            return fetch("api/UnreadMessageUser/List", {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            }).then(response => readJson(response, "api/UnreadMessageUser/List"))
                .then(results => {
                    if (!results) {
                        return;
                    }
                    dispatch({ type: "UNREAD_MESSAGE_FETCH", payload: results });
                })
                .catch(err => console.error("getUnreadMessagesFromDatabase failed:", err))
        }
    }
}

var setUnreadMessagesFromDb = (unreadUserIds) => {
    return dispatch => {
        const token = localStorage.token;
        if (token) {
            return fetch("api/UnreadMessageUser/SaveUnreadMessages", {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify(unreadUserIds)
            })
                // SaveUnreadMessages is a void action, so success is a 200
                // with an empty body - readJson's .json() would throw on it.
                // readStatus still drops a dead token, and the catch means a
                // failed save is reported instead of vanishing as an
                // unhandled rejection.
                .then(response => readStatus(response, "api/UnreadMessageUser/SaveUnreadMessages"))
                .catch(err => {
                    console.error("setUnreadMessagesFromDb failed:", err);
                    return null;
                })
        }
        return Promise.resolve(null);
    }
}

export default { 'GET_UNREAD_IDS': getUnreadMessagesFromDatabase, 'SET_UNREAD_IDS': setUnreadMessagesFromDb };


// WEBPACK FOOTER //
// ./src/actions/unread_message_actions.js


// WEBPACK FOOTER //
// ./src/actions/unread_message_actions.js